import { useEffect } from 'react'
import { IconAlertOctagonFilled, IconArrowLeft } from '@tabler/icons-react'

import { RecurlyContext } from 'features/checkout'
import Text from 'components/ui/text'
import { Button } from 'components/ui/buttons'
import ModalDialog from 'components/ui/modal-dialog'
import { translate } from 'utils/translation'
import { useContextSave } from 'hooks/use-context-save'

interface DeclinedUpdatePaymentModalProps {
  isDeclined: boolean
  setIsDeclined: (val: boolean) => void
}

export const DeclinedUpdatePaymentModal = ({
  isDeclined,
  setIsDeclined,
}: DeclinedUpdatePaymentModalProps) => {
  const context = useContextSave(RecurlyContext)
  const { setServerError, serverError } = context

  const onClose = () => {
    setServerError(null)
    setIsDeclined(false)
  }

  useEffect(() => {
    if (
      !isDeclined &&
      serverError?.message === 'request_failed' &&
      serverError?.type === 'error'
    ) {
      setIsDeclined(true)
    }
  }, [isDeclined, serverError?.message, serverError?.type])

  return (
    <ModalDialog
      maxSize="tw-max-w-2xl"
      variant="center"
      isOpen={isDeclined}
      onClose={onClose}
      icon={
        <IconAlertOctagonFilled className="tw-min-h-[48px] tw-min-w-12 tw-stroke-1 tw-text-rose-500" />
      }
      title={translate('card_info_declined_heading')}
      titleClassName="tw-text-3xl tw-px-8"
      containerClassName="tw-w-full"
      content={
        <>
          <Text className="tw-m-0 tw-text-center tw-text-lg tw-text-zinc-700">
            card_info_declined_subheading
          </Text>
          <Button
            variant="box"
            className="tw-mx-auto tw-mt-6 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-px-4 tw-py-2"
            onClick={onClose}
          >
            <IconArrowLeft className="tw-h-6 tw-min-h-6 tw-w-6 tw-min-w-6" />
            <Text className="tw-m-0 tw-text-base tw-font-medium">go_back</Text>
          </Button>
        </>
      }
      zIndex="tw-z-[100001]"
    />
  )
}
